import { IScope } from "angular";
import { IExtendedRootScopeService } from "@gtmhub/shared/ng-extensions";
import { ICollection } from "@webapp/core/core.models";
import { IPlanningSessionConflict, Session } from "@webapp/sessions/models/sessions.model";

interface IPlanningSessionConflictsScope extends IScope, IExtendedRootScopeService {
  session: Session;
  conflicts: ICollection<IPlanningSessionConflict>;
  ignoreAndClone: boolean;
  save(): void;
}

export class PlanningSessionConflictsCtrl {
  public static $inject = ["$scope", "conflicts", "session", "onSave", "ignoreAndClone"];

  constructor(
    private $scope: IPlanningSessionConflictsScope,
    private conflicts: ICollection<IPlanningSessionConflict>,
    private session: Session,
    private onSave: () => void,
    private ignoreAndClone: boolean
  ) {
    this.init();
  }

  private init = (): void => {
    this.$scope.ignoreAndClone = this.ignoreAndClone;
    this.$scope.session = this.session;
    this.$scope.conflicts = this.conflicts;
    this.$scope.save = this.onSave;
  };
}
